export const AddressSelectOverrides = {
  ControlContainer: {
    style: {
      height: '3.125rem',
    },
  },
}
